export enum Colors {
  Body = '#3d3d3d',
  MediumEmphasis = '#686868',
  Subscript = '#86888B',
  Superscript = '#86888B',
  Neutral = '#E9E9E9',
  White = 'white',
  Loading = '#dbdfe9',
}
